import SimpleBreadcrumbs from "../pages/components/simple-breadcrumbs/index.vue"
import Product from "@/components/product/index.vue";
import { globalLoader } from "@/helpers/variables"
import { mapActions, mapGetters } from "vuex";

export default {
    name: "promotion",
    components: {
        SimpleBreadcrumbs,
        Product
    },
    data() {
        return {
            timeRemaining: {
                days: 0,
                hours: 0,
                minutes: 0,
                seconds: 0
            },
            timerInterval: null,
            isExpired: false,
            products: []
        }
    },
    computed: {
        ...mapGetters({
            currentPromotion: "promotions/currentPromotion"
        }),
        formattedTimeRemaining() {
            if (this.isExpired) {
                return null;
            }
            const { days, hours, minutes, seconds } = this.timeRemaining;

            // Hide timer if everything is 0
            if (days === 0 && hours === 0 && minutes === 0 && seconds === 0) {
                return null;
            }

            const pluralizeDays = (days) => {
                const mod10 = days % 10;
                const mod100 = days % 100;
                if (mod10 === 1 && mod100 !== 11) return `${days} день`;
                if ([2, 3, 4].includes(mod10) && ![12, 13, 14].includes(mod100)) return `${days} дні`;
                return `${days} днів`;
            }

            if (days === 0) {
                return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
            }

            return `${pluralizeDays(days)} ${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
        },

    },
    methods: {
        ...mapActions({
            fetchPromotion: "promotions/FETCH_PROMOTION",
            fetchPromotionsProductsForBasket: "promotions/FETCH_PROMOTIONS_PRODUCTS_FOR_BASKET"
        }),
        parsePromotionEndTime(activeTo) {
            const [time, date] = activeTo.split(' ');
            const [hours, minutes, seconds] = time.split(':').map(Number);
            const [day, month, year] = date.split('-').map(Number);
            
            return new Date(year, month - 1, day, hours, minutes, seconds);
        },
        calculateTimeRemaining() {
            if (!this.currentPromotion?.activeTo) {
                return;
            }
            
            const endTime = this.parsePromotionEndTime(this.currentPromotion.activeTo);
            const now = new Date();
            const timeDiff = endTime.getTime() - now.getTime();
            
            if (timeDiff <= 0) {
                this.isExpired = true;
                this.timeRemaining = { days: 0, hours: 0, minutes: 0, seconds: 0 };
                if (this.timerInterval) {
                    clearInterval(this.timerInterval);
                    this.timerInterval = null;
                }
                return;
            }
            
            const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
            const hours = Math.floor((timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);
            
            this.timeRemaining = { days, hours, minutes, seconds };
            this.isExpired = false;
        },
        startTimer() {
            this.calculateTimeRemaining();
            this.timerInterval = setInterval(() => {
                this.calculateTimeRemaining();
            }, 1000);
        }
    },
    async created() {
        globalLoader(true);
        try {
            const response = await this.fetchPromotion(this.$route.params.promotionId);
            const basketIds = response.basketIds.map(product => product.productId);
            const products = await this.fetchPromotionsProductsForBasket(basketIds);
            this.products = products.data;
            this.$nextTick(() => {
                this.startTimer();
            });
        } catch (error) {
            this.$router.push(this.$localize({ name: "main" }));
        } finally {
            globalLoader(false);
        }
    },
    beforeDestroy() {
        if (this.timerInterval) {
            clearInterval(this.timerInterval);
        }
    }
}